import React, { memo } from 'react';
import cc from 'classcat';
import { TypographyCQ } from 'components/Typography';
import type { Metadata } from 'lib/metadata';
import './gameInfo.css';

interface GameInfoProps {
  isActive?: boolean;
  metadata?: Metadata;
}

const GameInfo = ({ isActive, metadata }: GameInfoProps) => {
  const rtpLabel = metadata?.rtp?.label;
  const rtpString = metadata?.rtp?.formattedValue;
  const classNames = cc([
    'gameInfo',
    {
      'gameInfo--show': isActive
    }
  ]);

  return !rtpString ? null : (
    <div className={classNames}>
      <TypographyCQ name="rtpLabel">
        <p className="gameInfo__rtpLabel">{rtpLabel}</p>
      </TypographyCQ>
      <TypographyCQ name="rtpValue">
        <p className="gameInfo__rtpValue">{rtpString}</p>
      </TypographyCQ>
    </div>
  );
};

export default memo(GameInfo);
